import PropTypes from 'prop-types';
import { Chip, Typography } from '@mui/material';

const styles = {
  chip: ({ spacing }) => ({
    height: 'auto',
    '.MuiChip-label': {
      padding: spacing(0.5, 3),
    },
  }),
};

export const NomineeRoleChip = ({ name, bg = null, textColor = null }) => {
  return (
    <Chip
      label={
        <Typography component="span" variant="body2-bold" color={textColor || 'text.primary'}>
          {name}
        </Typography>
      }
      sx={[styles.chip, { backgroundColor: bg }]}
    />
  );
};

NomineeRoleChip.propTypes = {
  name: PropTypes.string.isRequired,
  bg: PropTypes.string,
  textColor: PropTypes.string,
};
